<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver">
            <i class="fa fa-chevron-left"></i></button>

        <button *ngIf="hasAddingAccess" [disabled]="!allowToAdd" type="button" class="btn btn-outline-success" (click)="onClickAdd()" title="Añadir {{ title.plural }}">
            <i class="fa fa-file-o"></i> Añadir {{ title.plural }}</button>

        <button *ngIf="hasDeleteAccess" [disabled]="actionNotAllowed" type="button" class="btn btn-outline-success" (click)="onClickDeleteUi()" title="Eliminar U.I.">
            <i class="fa fa-times"></i> Eliminar</button>

        <button *ngIf="hasBajaAccess" [disabled]="actionNotAllowed" type="button" class="btn btn-outline-success" (click)="onClickBajaUi()" title="Dar de baja U.I.: Se darán de baja sus {{ title.plural }} en el Periodo actual. No podrán ser usados en ninguna U.I. o solicitud del periodo.">
            <i class="fa fa-archive"></i> Dar de Baja</button>

        <button *ngIf="hasSuspenderAccess" [disabled]="actionNotAllowed" type="button" class="btn btn-outline-success" (click)="onClickSuspenderUi()" title="Suspender U.I.: Todos los {{ title.plural }} incuidos en la U.I. se incluirán en la lista negra. No podrán ser utilizados en toda la campaña.">
            <i class="fa fa-ban"></i> Suspender</button>

        <button *ngIf="visibilitySpinnerGuardando" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>

        <div *ngIf="hasDeleteAccess" class="nota-info m-1">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Eliminar la U.I. implica suprimir la vinculación con sus {{ title.plural }}</label>
        </div>
    </form>
</nav>

<div class="container-fluid container-list">
    
    <div class="row ps-2 pt-2" *ngIf="periodoForUi && esTipoSolicitudPI">
        <ng-container *ngIf="periodoForUi?.TamanioMaximoAgrupacion && superficieAcumulada">
            <div class="col-3 col-lg-6 nota-info mt-2" role="alert">
                <label class="col-form-label"><i class="fa fa-info-circle" aria-hidden="true"></i> Superficie de cultivos en la U.I.: {{ superficieAcumulada | number:'1.2-5':'es-ES' }} ha</label>
            </div>
        </ng-container>
        <ng-container *ngIf="!periodoForUi?.TamanioMaximoAgrupacion">
            <div class="col-4 col-lg-6 nota-info mt-2" role="alert">
                <label class="col-form-label"><i class="fa fa-info-circle" aria-hidden="true"></i> Superficie máxima de agrupación (ha): Sin límite</label>
            </div>
        </ng-container>
        <ng-container *ngIf="periodoForUi?.TamanioMaximoAgrupacion">
            <div class="col-3 col-lg-6 nota-info mt-2" role="alert">
                <label class="col-form-label"><i class="fa fa-info-circle" aria-hidden="true"></i> Superficie máxima de agrupación: {{ periodoForUi.SuperficieMax | number:'1.2-5':'es-ES' }} ha</label>
            </div>
        </ng-container>        
    </div>

    <h4 class="pt-2 pb-1">Detalle de la Unidad de Inspección</h4>

    <app-unidad-inspeccion-header *ngIf="unidadInspeccion?.FirstRecinto" [formGroup]="formGroup" [unidadInspeccion]="unidadInspeccion"></app-unidad-inspeccion-header>

    <!-- Componentes relacionados con los Recintos "PIAEd" -->
    <app-unidad-inspeccion-list *ngIf="unidadInspeccion && recintoUnidadInspeccionList"
        [userData]="userData"
        [readonly]="readonly" [title]="title" [result]="recintoUnidadInspeccionList" 
        (view)="onView($event)" (delete)="onDelete($event)"></app-unidad-inspeccion-list>
</div>

<!-- Ventana para mostrar el detalle de un recinto PI y sus cultivos -->
<app-recinto-detail-dialog [visible]="recintoDetailVisible" [Id]="recintoPIAIdSelected" [editMode]="false" (closed)="onRecintoDialogClosed($event)"></app-recinto-detail-dialog>

<!-- Ventana para mostrar el detalle de un Almacén -->
<app-codigoconfeccion-detail-dialog [visible]="almacenDetailVisible" [Id]="recintoPIAIdSelected" (closed)="onRecintoDialogClosed($event)"></app-codigoconfeccion-detail-dialog>

<!-- Ventana para mostrar el detalle de una Empresa Deshidratadora -->
<app-empresadeshidratadora-detail-dialog [visible]="empresaDetailVisible" [Id]="recintoPIAIdSelected" (closed)="onRecintoDialogClosed($event)"></app-empresadeshidratadora-detail-dialog>